// @generated by protoc-gen-connect-query v2.3.1 with parameter "target=ts"
// @generated from file travplaces/v1/places.proto (package travplaces.v1, syntax proto3)
/* eslint-disable */

import { PlacesService } from "./places_pb";

/**
 * SearchExternal searches the external provider within a city's bounding
 * box. `available` is false when no provider key is configured (or the
 * provider call failed); in that case results_json is "[]".
 *
 * @generated from rpc travplaces.v1.PlacesService.SearchExternal
 */
export const searchExternal = PlacesService.method.searchExternal;

/**
 * DescribePlace names whatever is at a coordinate, for labelling a pin
 * dropped on the map.
 *
 * @generated from rpc travplaces.v1.PlacesService.DescribePlace
 */
export const describePlace = PlacesService.method.describePlace;
